import { render, staticRenderFns } from "./ProducerFormCommission.vue?vue&type=template&id=a6e6ecdc&scoped=true&"
import script from "./ProducerFormCommission.vue?vue&type=script&lang=ts&"
export * from "./ProducerFormCommission.vue?vue&type=script&lang=ts&"
import style0 from "./ProducerFormCommission.vue?vue&type=style&index=0&id=a6e6ecdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e6ecdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
